import { BoxProps } from '@chakra-ui/react';
import { MBox } from '../../../../../components/Monetize';

/**
 * The bordered card every offering run sits in once a quote has groups —
 * the group containers and the Ungrouped container alike, so no run can read
 * as belonging to the box above it.
 *
 * The negative horizontal margin lets the box's own 1px border sit outside the
 * offering grid's width, keeping the columns inside aligned with the table
 * header above it.
 */
export const QuoteOfferingGroupBox = ({ children, ...boxProps }: BoxProps) => (
  <MBox
    borderWidth="1px"
    borderStyle="solid"
    borderColor="border.subtle"
    borderRadius="md"
    bg="bg.surface"
    boxShadow="xs"
    overflow="hidden"
    mx="-1px"
    my={4}
    {...boxProps}
  >
    {children}
  </MBox>
);
